// extracted by mini-css-extract-plugin
module.exports = {"root":"headerTitle_root__2cexF","headerIteam":"headerTitle_headerIteam__1FEi7"};